



export class TableColumnVisibilityController {

    tableId: string;
    dropdownDivId: string;
    dropdownId: string;
    columnGroups: TableColumnGroup[];

    constructor(tableId: string, dropdownDivId: string, columnGroups: TableColumnGroup[]) {
        this.tableId = tableId;
        this.dropdownDivId = dropdownDivId;
        this.columnGroups = columnGroups;

        this.dropdownId = tableId + "-column-filter-dropdown";

        $('#' + dropdownDivId).empty().html("<div class=\"row mx-0 w-100\"><label for=\"" + this.dropdownId + "\" class=\"col-form-label filter-label py-0\">Column Categories to View</label><select id=\"" + this.dropdownId + "\" class=\"selectpicker dropdown w-100\" title=\"None Selected\" data-actions-box=\"true\" data-live-search=\"false\" data-container=\"body\" multiple></select></div>");

        $('#' + this.dropdownId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All Available";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        this.columnGroups.forEach((group: TableColumnGroup) => {
            $('#' + this.dropdownId).append(new Option(group.name, group.name, false, group.visible));
        });
        $('#' + this.dropdownId).selectpicker("refresh");

        $('#' + this.dropdownId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            this.updateColumnVisibility();
        });
        this.updateColumnVisibility();
    }

    refresh(): void {
        $('#' + this.dropdownId).selectpicker("refresh");
    }

    updateColumnVisibility(): void {

        let values: string[] = <string[]>($('#' + this.dropdownId).val());

        let visibleColumns: number[] = [];
        let visibleStyles: string[] = [];
        let hiddenColumns: number[] = [];
        let hiddenStyles: string[] = [];
        this.columnGroups.forEach((colgroup: TableColumnGroup) => {
            if (values.includes(colgroup.name)) {
                visibleColumns.push(...colgroup.columns);
                if (colgroup.columnStyle.length > 0) { visibleStyles.push(colgroup.columnStyle); }
            }
            else {
                hiddenColumns.push(...colgroup.columns);
                if (colgroup.columnStyle.length > 0) { hiddenStyles.push(colgroup.columnStyle); }
            }
        });

        var table = $('#' + this.tableId).DataTable();
        if (hiddenColumns.length > 0) { table.columns(hiddenColumns).visible(false, false); }
        if (visibleColumns.length > 0) { table.columns(visibleColumns).visible(true, false); }

        hiddenStyles.forEach((style: string) => {
            table.columns('.' + style).visible(false, false);
        });
        visibleStyles.forEach((style: string) => {
            table.columns('.' + style).visible(true, false);
        });

        table.columns.adjust().draw(false); // adjust column sizing and redraw

    }
}

export class TableColumnVisibilityControllerV2 {

    tableId: string;
    columnGroups: TableColumnGroup[];
    uniqueId: string;

    constructor(tableId: string, dropdownDivId: string, columnGroups: TableColumnGroup[], uniqueString: string) {
        this.tableId = tableId;
        this.columnGroups = columnGroups;
        let uniqueId = "column-filter-dropdown-" + uniqueString;
        this.uniqueId = uniqueId;

        $(dropdownDivId).empty().html(
            `<div class=\"row mx-0 w-100\">
                <div class=\"w-100\">
                    <label for="${uniqueId}" class=\"col-form-label filter-label py-0\">Columns to View</label>
                    <select id="${uniqueId}" class=\"selectpicker dropdown\" title=\"None Selected\" data-actions-box=\"true\" data-live-search=\"false\" data-container=\"body\" data-width=\"100%\" multiple></select>
                </div>
            </div>`
        );

        $(`#${uniqueId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All Available";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });
        this.columnGroups.forEach((group: TableColumnGroup) => {
            $(`#${uniqueId}`).append(new Option(group.name, group.name, false, group.visible));
        });
        $(`#${uniqueId}`).selectpicker("refresh");


        $(`#${uniqueId}`).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            this.updateColumnVisibility();
        });
        this.updateColumnVisibility();

    }

    refresh(): void {
        $(`#${this.uniqueId}`).selectpicker("refresh");
    }

    updateColumnVisibility(): void {

        let values: string[] = <string[]>($(`#${this.uniqueId}`).val());
        let visibleColumns: number[] = [];
        let visibleStyles: string[] = [];
        let hiddenColumns: number[] = [];
        let hiddenStyles: string[] = [];
        this.columnGroups.forEach((colgroup: TableColumnGroup) => {
            if (values.includes(colgroup.name)) {
                visibleColumns.push(...colgroup.columns);
                if (colgroup.columnStyle.length > 0) { visibleStyles.push(colgroup.columnStyle); }
            }
            else {
                hiddenColumns.push(...colgroup.columns);
                if (colgroup.columnStyle.length > 0) { hiddenStyles.push(colgroup.columnStyle); }
            }
        });

        var table = $(this.tableId).DataTable();
        if (hiddenColumns.length > 0) { table.columns(hiddenColumns).visible(false, false); }
        if (visibleColumns.length > 0) { table.columns(visibleColumns).visible(true, false); }

        hiddenStyles.forEach((style: string) => {
            table.columns('.' + style).visible(false, false);
        });
        visibleStyles.forEach((style: string) => {
            table.columns('.' + style).visible(true, false);
        });

        table.columns.adjust().draw(false); // adjust column sizing and redraw

    }
}


export class TableColumnGroup {
    name: string;
    visible: boolean;
    columns: number[];
    columnStyle: string;

    constructor(name: string, visible: boolean, columns: number[], columnStyle: string) {
        this.name = name;
        this.visible = visible;
        this.columns = columns;
        this.columnStyle = columnStyle;
    }
}